import { ArrowBack as ArrowBackIcon } from '@mui/icons-material/';
import { Button, Paper, PaperProps } from '@mui/material';
import { Box } from '@mui/system';
import { ReactNode, useCallback, ComponentProps } from 'react';
import { useNavigate } from 'react-router-dom';

import { SubPageTitle } from '@app/components/Shared/SubPageTitle';

export interface UserLayoutProps extends PaperProps {
  children?: ReactNode;
}

export function UserLayout({ children, ...paperProps }: UserLayoutProps) {
  const navigate = useNavigate();

  const handleClickToProduct: NonNullable<
    ComponentProps<typeof Button>['onClick']
  > = useCallback(() => {
    navigate('/users');
  }, [navigate]);

  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center" mb={3} mt={1}>
        <Button
          color="secondary"
          variant="outlined"
          sx={{ height: '40px', mr: 2, width: '40px' }}
          onClick={handleClickToProduct}
          data-e2e="product-detail-back-btn"
        >
          <ArrowBackIcon color="action" />
        </Button>
        <SubPageTitle title="医師一覧" />
      </Box>
      <Paper
        {...paperProps}
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minHeight: 660,
            p: 3,
          },
          // https://mui.com/system/getting-started/the-sx-prop/#passing-the-sx-prop
          ...(Array.isArray(paperProps.sx) ? paperProps.sx : [paperProps.sx]),
        ]}
      >
        {children}
      </Paper>
    </>
  );
}
